<app-page-title title="Login / Register Account" [children]="[{title: 'Account', link: '/account'}, {title: 'Login / Register'}]"></app-page-title>

<!-- Page Content -->
<div class="max-w-lg mx-auto px-6 py-12">
  <div class="bg-white rounded-xl shadow-lg p-8">
    <!-- Toggle Header -->
    <div class="flex justify-between items-center mb-6">
      <h3 class="text-2xl font-serif text-gold">{{ isLoginMode ? 'Login' : 'Register' }}</h3>
      <button class="text-sm text-gold hover:text-gold-dark underline transition duration-300" (click)="toggleMode()">
        {{ isLoginMode ? 'Need an account? Sign Up' : 'Already have an account? Log In' }}
      </button>
    </div>

    <!-- Login Form -->
    <form *ngIf="isLoginMode" [formGroup]="loginForm" (ngSubmit)="onLogin()" class="space-y-6">
      <div class="form-group">
        <label for="login-email" class="block text-lg font-serif text-gold mb-2">Email Address</label>
        <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
               type="email" id="login-email" formControlName="email" placeholder="Email">
        <div *ngIf="!loginForm.get('email').valid && loginForm.get('email').touched" class="text-red-500 text-sm mt-1">
          Be sure to enter a valid email.
        </div>
      </div>

      <div class="form-group">
        <label for="login-password" class="block text-lg font-serif text-gold mb-2">Password</label>
        <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
               type="password" id="login-password" formControlName="password" placeholder="Password">
        <div *ngIf="!loginForm.get('password').valid && loginForm.get('password').touched" class="text-red-500 text-sm mt-1">
          The password seems to be incorrect.
        </div>
      </div>

      <div class="text-right">
        <button [disabled]="!loginForm.valid" 
                class="add-to-cart-btn flex items-center justify-center transition-all duration-300 relative overflow-hidden bg-gradient-to-r from-gold to-yellow-600 hover:from-red-700 hover:to-red-600 text-white font-serif text-base sm:text-lg font-bold px-6 py-3 rounded-full"
                type="submit">
          <span class="flex items-center">
            <i class="fas fa-sign-in-alt mr-2"></i>
            <span>Login</span>
          </span>
        </button>
      </div>
    </form>

    <!-- Register Form -->
    <form *ngIf="!isLoginMode" [formGroup]="registerForm" (ngSubmit)="onRegister()" class="space-y-6">
      <div class="form-group">
        <label for="reg-email" class="block text-lg font-serif text-gold mb-2">Email Address</label>
        <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
               type="email" id="reg-email" formControlName="email" placeholder="Email">
        <div *ngIf="!registerForm.get('email').valid && registerForm.get('email').touched" class="text-red-500 text-sm mt-1">
          Be sure to enter a valid email.
        </div>
      </div>

      <div class="form-group">
        <label for="reg-pass" class="block text-lg font-serif text-gold mb-2">Password</label>
        <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
               type="password" id="reg-pass" formControlName="password" placeholder="Password">
        <div *ngIf="!registerForm.get('password').valid && registerForm.get('password').touched" class="text-red-500 text-sm mt-1">
          Password is required.
        </div>
      </div>

      <div class="form-group">
        <label for="reg-pass-confirm" class="block text-lg font-serif text-gold mb-2">Confirm Password</label>
        <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
               type="password" id="reg-pass-confirm" formControlName="confirmPassword" placeholder="Confirm Password">
        <div *ngIf="!registerForm.get('confirmPassword').valid && registerForm.get('confirmPassword').touched" class="text-red-500 text-sm mt-1">
          Confirmation password is required.
        </div>
      </div>

      <div class="text-red-500 text-sm mb-4" *ngIf="registerErrors">{{ registerErrors }}</div>

      <div class="text-right">
        <button [disabled]="!registerForm.valid" 
                class="add-to-cart-btn flex items-center justify-center transition-all duration-300 relative overflow-hidden bg-gradient-to-r from-gold to-yellow-600 hover:from-red-700 hover:to-red-600 text-white font-serif text-base sm:text-lg font-bold px-6 py-3 rounded-full"
                type="submit">
          <span class="flex items-center">
            <i class="fas fa-user-plus mr-2"></i>
            <span>Register</span>
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
